var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9468 27.7599C42.9068 28.7999 41.1735 28.7999 40.1335 27.7599L28.2135 15.8666L9.41348 34.6399L7.65348 32.9599C4.53348 29.8399 4.53348 24.7732 7.65348 21.6532L18.9601 10.3466C22.0801 7.22657 27.1468 7.22657 30.2668 10.3466L43.9468 23.9999C44.9868 25.0399 44.9868 26.7199 43.9468 27.7599ZM45.8135 22.1066C47.8935 24.1866 47.8935 27.5732 45.8135 29.6532C42.4268 33.0399 38.8535 30.2399 38.2668 29.6532L28.2401 19.6266L13.3868 34.4799C12.3468 35.5199 12.3468 37.1999 13.3868 38.2399C14.4268 39.2799 16.1068 39.2799 17.1735 38.2399L29.4935 25.9199L31.3868 27.8132L19.0668 40.1332C18.0268 41.1732 18.0268 42.8532 19.0668 43.8932C20.1068 44.9332 21.7868 44.9332 22.8535 43.8932L35.1735 31.5732L37.0668 33.4666L24.7468 45.7866C23.7068 46.8266 23.7068 48.5066 24.7468 49.5466C25.7868 50.5866 27.4668 50.5866 28.5068 49.5466L40.8268 37.2266L42.7201 39.1199L30.4001 51.4399C29.3601 52.4799 29.3601 54.1599 30.4001 55.1999C31.4401 56.2399 33.1201 56.2399 34.1601 55.1999L56.3468 32.9599C59.4668 29.8399 59.4668 24.7732 56.3468 21.6532L45.0401 10.3466C41.9735 7.2799 37.0135 7.22657 33.8935 10.1866L45.8135 22.1066Z",
    fill: "#EC5B71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.d42fb1f9b04cfb18fc5dba02c73e52dd.svg";
export { ForwardRef as ReactComponent };